/**
 * Copy `text` to the clipboard. Tries the async Clipboard API first, falls back to a
 * hidden textarea + execCommand("copy") for environments without it (or that reject
 * the call, e.g. lack of a secure context or user permission).
 * Returns true on success, false if both paths fail.
 */
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    try {
      ta.select();
      return document.execCommand("copy");
    } catch {
      return false;
    } finally {
      document.body.removeChild(ta);
    }
  }
}
